/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* HT Darts: collection/category header logo */
document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-collection')) return;

  var header = document.querySelector('.collection__dynamic-part .card__header .collection__header-inner');
  if (!header || header.querySelector('.htd-category-header-logo')) return;

  var link = document.createElement('a');
  link.className = 'htd-category-header-logo';
  link.href = '/';
  link.setAttribute('aria-label', 'HT Darts home');

  var logo = document.createElement('img');
  logo.src = '/cdn/shop/files/7f91f714-e4f7-4c92-ba2e-8bd47b001131.png';
  logo.alt = 'HT Darts';
  logo.loading = 'eager';
  link.appendChild(logo);
  header.appendChild(link);

  var style = document.createElement('style');
  style.textContent = '.template-collection .collection__header-inner{position:relative;padding-right:230px}.htd-category-header-logo{position:absolute;right:24px;top:50%;transform:translateY(-50%);display:flex;align-items:center;justify-content:flex-end;max-width:190px;z-index:2}.htd-category-header-logo img{display:block;width:auto;max-width:190px;max-height:82px;object-fit:contain}@media(max-width:640px){.template-collection .collection__header-inner{padding-right:112px}.htd-category-header-logo{right:14px;max-width:92px}.htd-category-header-logo img{max-width:92px;max-height:52px}}';
  document.head.appendChild(style);
});
